import {Injectable} from '@angular/core';
import {MatSnackBar} from '@angular/material/snack-bar';
import {OphSnackbarComponent} from '../shared/design/oph-snackbar/oph-snackbar.component';

@Injectable({
  providedIn: 'root',
})
export class MessageService {
  messages: string[] = [];

  constructor(private snackBar: MatSnackBar) {}

  add(message: string, type?: 'newTaskAssigned' | 'taskTriggered' | 'taskCompleted' | 'error') {
    this.snackBar.openFromComponent(OphSnackbarComponent, {
      data: {
        message,
        type,
      },
      duration: undefined, // Let the component control the duration
    });
  }

  clear(message: string) {
    this.messages = this.messages.filter(m => m !== message);
  }
}
